function setupKueSwatches() {
  document
    .querySelectorAll('.product-grid .ul-swatches-list')
    .forEach(function (list) {

      if (list.dataset.kueReady === 'true') return;

      const items = Array.from(
        list.querySelectorAll(':scope > li.swatches-options')
      );

      if (items.length <= 4) {
        list.dataset.kueReady = 'true';
        return;
      }

      items.forEach(function (item, index) {
        if (index >= 4) {
          item.classList.add('kue-swatch-extra');
        }
      });

      const toggleItem = document.createElement('li');
      toggleItem.className = 'kue-swatch-toggle';

      const toggleButton = document.createElement('button');
      toggleButton.type = 'button';
      toggleButton.textContent = '+';
      toggleButton.setAttribute('aria-label', 'Show more variants');
      toggleButton.setAttribute('aria-expanded', 'false');

      toggleItem.appendChild(toggleButton);
      list.appendChild(toggleItem);

      list.dataset.kueReady = 'true';
    });
}


function initKueSwatches() {

  setupKueSwatches();

  document.addEventListener('click', function (event) {

    const button = event.target.closest(
      '.product-grid .kue-swatch-toggle button'
    );

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const list = button.closest('.ul-swatches-list');

    if (!list) return;

    const card = button.closest('.card-wrapper');

    const expanded =
      list.classList.toggle('kue-swatches-open');

    if (card) {
      card.classList.toggle(
        'kue-card-expanded',
        expanded
      );
    }

    button.textContent = expanded ? '−' : '+';

    button.setAttribute(
      'aria-expanded',
      expanded ? 'true' : 'false'
    );

    button.setAttribute(
      'aria-label',
      expanded
        ? 'Hide variants'
        : 'Show more variants'
    );

  });


  const observer = new MutationObserver(function () {
    setupKueSwatches();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

}


if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initKueSwatches
  );
} else {
  initKueSwatches();
}